import keyBy from 'lodash/keyBy';

export default {
  project: state => state.project,
  order: state => state.order,
  languages: state => state.project.languages,
  languageDefault: state =>
    state.project.languages.find(lang => lang.default) ||
    state.project.languages[0],
  pages: state => (state.project ? state.project.pages : []),
  projectLogo: state => (state.project ? state.project.logo : ''),
  statuses: state => (state.project ? state.project.statuses : []),
  statusMapByName: (_, getters) => keyBy(getters.statuses, 'name'),
  statusMapById: (_, getters) => keyBy(getters.statuses, 'status_id'),
  settings: state => (state.project ? state.project.settings : {}),
  statusSwitch: state => (state.project ? state.project.status_switch : true),
  statusSwitchMobileOff: state =>
    state.project && state.project.status_switch_mobile_off,
  agents: state => (state.project ? state.project.agents : []),
  brokerCompany: state => (state.project ? state.project.broker_company : {}),
  contactsModules: state =>
    (state.project ? state.project.contact_modules : {}),
  attributes: state => (state.project ? state.project.attributes || [] : []),
  styleDefault: state =>
    state.project.styles.filter(style => style.default && style.collection_id),
  styles: state => state.project.styles,
  panoramaGroups: state => state.project.panorama_groups,
  i18nTranslations: state => state.i18nTranslations,
  contactFormEnabledOnContactPage: (_, getters) => !!getters.settings.form_contact_page,
  contactFormEnabledOnUnitPage: (_, getters) => !!getters.settings.form_unit_page,
  floorPlanOnTooltipShowing: (_, getters) => !!getters.settings.flp_preview,
  floorPlan2DFirstShowing: (_, getters) => !!getters.settings.unit_2d_first,
  showOverlayStatus: ({ project }) => project && !project.status_switch_hidden,
  showExternalFloorPlan: ({ project }) => project && !!project.ext_flp,
  showExternalPdf: ({ project }) => project && !!project.ext_pdf,
  sortStatusesByWeight: (_, getters) => (a, b) => getters.statusMapByName[a].position -
    getters.statusMapByName[b].position,
  filterOutDisabledOverlays: (_, getters, __, rootGetters) => {
    const { statusMapById: statusById } = getters;
    const {
      'exteriors/exteriorMapById': exteriorById,
      'units/normalizedUnitById': unitById,
    } = rootGetters;

    return overlays =>
      overlays.filter((overlay) => {
        const {
          status_id: statusId,
          linked_exterior_id: exteriorId,
          unit_id: unitId,
        } = overlay;

        // there can be overlay with statusId = null, it's ok
        return (!statusId || !statusById[statusId] ||
            statusById[statusId].display_default)
          &&
          (!exteriorId || !exteriorById[exteriorId] ||
            exteriorById[exteriorId].display_navigator)
          &&
          (!unitId || (
            unitById(unitId) && unitById(unitId).unit.display_navigator)
          ); // not show if no bound unit
      });
  },
};
